import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import type {
  onChangeEventsInterface,
  useSearchFilterHookStates
} from "./internal";
import onChangeEvents from "./internal/onChangeEvents";
export function handleOnChangeEvents(
  currentStates: useSearchFilterHookStates,
  updateSearchRequest: (
    newSearchRequest?: dealerSearchIncoming | undefined
  ) => void,
  filters: dealerSearchIncoming
): onChangeEventsInterface {
  const accountTypesOnChange = onChangeEvents.getaccountTypesOnChange(
    currentStates.setAccountTypesValue,
    updateSearchRequest
  );
  const CountryOnChange = onChangeEvents.getCountryOnChange(
    currentStates.setSelectedCountryValue,
    updateSearchRequest
  );
  const urlOnChange = onChangeEvents.geturlOnChange(
    currentStates.setSelectedUrlValue,
    updateSearchRequest
  );
  const controlCenterPlatformnsChange =
    onChangeEvents.getcontrolCenterPlatformnsChange(
      currentStates.setControlCenterPlatformsValue,
      updateSearchRequest
    );
  const idOnChange = onChangeEvents.getidOnChange(
    currentStates.setIdValue,
    updateSearchRequest
  );
  const nameOnChange = onChangeEvents.getnameOnChange(
    currentStates.setNameValue,
    updateSearchRequest
  );
  const verticalTypesnChange = onChangeEvents.getverticalTypesnChange(
    currentStates.setVerticalTypesValue,
    updateSearchRequest
  );
  const postalCodeOnChange = onChangeEvents.getpostalCodeOnChange(
    currentStates.setPostalCodeValue,
    updateSearchRequest
  );
  const StatusesOnChange = onChangeEvents.getStatusesOnChange(
    currentStates.setStatusValue,
    updateSearchRequest
  );
  const dateAfterOnChange = onChangeEvents.getDateAfterOnChange(
    currentStates.setDateAfterValue,
    updateSearchRequest,
    filters
  );
  const dateBeforeOnChange = onChangeEvents.getDateBeforeOnChange(
    currentStates.setDateBeforeValue,
    updateSearchRequest,
    filters
  );
  const StatesOnChange = onChangeEvents.getStatesOnChange(
    currentStates.setSelectedStateValue,
    updateSearchRequest
  );
  const franchisesMatchAllOnChange =
    onChangeEvents.getfranchisesMatchAllOnChange(
      currentStates.setFranchisesMatchAllValue,
      updateSearchRequest,
      filters
    );
  const franchisesMatchAnyOnChange =
    onChangeEvents.getfranchisesMatchAnyOnChange(
      currentStates.setFranchisesMatchAnyValue,
      updateSearchRequest,
      filters
    );
  const franchisesMatchNoneOnChange =
    onChangeEvents.getfranchisesMatchNoneOnChange(
      currentStates.setFranchisesMatchNoneValue,
      updateSearchRequest,
      filters
    );
  const dealerCodesValueMatchAllOnChange =
    onChangeEvents.getdealerCodesValueMatchAllOnChange(
      currentStates.setDealerCodesValueMatchAll,
      updateSearchRequest,
      filters
    );
  const dealerCodesMatchAllOnChange =
    onChangeEvents.getdealerCodesMatchAllOnChange(
      currentStates.setDealerCodesMatchAll,
      updateSearchRequest,
      filters
    );
  const resourcesMatchAllOnChange = onChangeEvents.getresourcesMatchAllOnChange(
    currentStates.setResourcesMatchAllValue,
    updateSearchRequest,
    filters
  );
  const resourcesMatchAnyOnChange = onChangeEvents.getresourcesMatchAnyOnChange(
    currentStates.setResourcesMatchAnyValue,
    updateSearchRequest,
    filters
  );
  const resourcesMatchNoneOnChange =
    onChangeEvents.getresourcesMatchNoneOnChange(
      currentStates.setResourcesMatchNoneValue,
      updateSearchRequest,
      filters
    );
  return {
    accountTypesOnChange,
    CountryOnChange,
    urlOnChange,
    controlCenterPlatformnsChange,
    idOnChange,
    nameOnChange,
    verticalTypesnChange,
    postalCodeOnChange,
    StatusesOnChange,
    dateAfterOnChange,
    dateBeforeOnChange,
    StatesOnChange,
    franchisesMatchAllOnChange,
    franchisesMatchAnyOnChange,
    franchisesMatchNoneOnChange,
    dealerCodesValueMatchAllOnChange,
    dealerCodesMatchAllOnChange,
    resourcesMatchAllOnChange,
    resourcesMatchAnyOnChange,
    resourcesMatchNoneOnChange
  };
}
